var ModuleSelectorType;
(function (ModuleSelectorType) {
    /**
     * Linear type, can work by itself. To render on top of everything it needs to be rendered with ReactDOM.createPortal() directly on the body of the document.
     */
    ModuleSelectorType["LINEAR"] = "linear";
    /**
     * Spotlight type, will render normally, needs to be inside a spotlight to work properly.
     */
    ModuleSelectorType["SPOTLIGHT"] = "spotlight";
})(ModuleSelectorType || (ModuleSelectorType = {}));
export { ModuleSelectorType, };
//# sourceMappingURL=module-selector-constants.js.map